import axios from "axios"

export default {
	listVerifications(ctx) {
		return axios.get("/v1/verifications", { params: ctx })
	}
}